import request from '@/utils/http';

const costName = {
// 获取列表
    get(params) {
        return request({
            url: `/api-srm-web/contract/contractWarningConfigs`,
            method: 'post',
            data: params
        });
    },
    // 新增
    addSave(params) {
        return request({
            url: '/api-srm-web/contract/contractWarningConfig',
            method: 'post',
            data: params
        });
    },
    // 修改
    editSave(params, id) {
        return request({
            url: `/api-srm-web/contract/contractWarningConfig/${id}`,
            method: 'PUT',
            data: params
        });
    },
    // 保存
    save(params) {
        return request({
            url: `/api-srm-web/contract/contractWarningConfig`,
            method: 'post',
            data: params
        });
    },
    // 删除
    del(id) {
        return request({
            url: `/api-srm-web/contract/contractWarningConfig/${id}`,
            method: 'DELETE'
        });
    },
    // 启动、停用
    editStatus(params, id) {
        return request({
            url: `/api-srm-web/contract/contractWarningConfig/updateStatus/${id}`,
            method: 'PUT',
            data: params
        });
    }
};
export default costName;
